import React, { useEffect, useRef, useState } from "react"
import { Header } from "~/components/templates/Header"
import { VerifyFooter } from "~/components/templates/VerifyFooter"
import { CommonMeta } from "~/components/templates/CommonMeta"
import Customer from "~/components/templates/simulator/Customer"
import { Customer as CustomerData } from "~/models/Customer"
import { METAS } from "~/data/constants/MetaData"
import { PageKey, SimulatorMode } from "~/models/Page"
import { useRouter } from "next/router"

export default function Index() {

  const router = useRouter()
  const currentPage = PageKey.Customer
  const customerRef = useRef<{ save: () => Promise<boolean> }>()
  const [isValid, isValidState] = useState(false)
  const [customer, customerState] = useState<CustomerData>({} as CustomerData)
  const [isNext, setIsNext] = useState(null)

  const action = async () => {
    const result = await customerRef.current?.save.apply(this, [!isNext])
    if (result) {
      if (isNext) {
        router.push(`/simulator/${SimulatorMode.Simplified}/${PageKey.Recommend}`)
      } else {
        router.push("/simulator/success")
      }
    } else {
      console.info("処理失敗")
    }
  }

  useEffect(() => {
    setIsNext(Boolean(customer.accessTokenId && customer.estimateId))
  }, [customer])

  return (
    <>
      {METAS[currentPage] && <CommonMeta metaData={METAS[currentPage]} />}
      <Header />
      <div className="wrapper">
        <div className="main simple-simulator customer">
          <div className="persistent-header" id="persistent">
            <div className="inner">
              <div className="pack-info-area d-flex align-items-center justify-content-between">
                <div className="pack-info">
                  <div className="pack-choice-title">
                    <span>はじめまして。お客様のこと教えてください。</span>
                  </div>
                  <div className="pack-info-text">
                    事業内容を選択してください。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Customer ref={customerRef} onValidChange={isValidState} onDataChange={customerState}
            footerComponent={<VerifyFooter isValid={isValid} customer={customer} onAction={action}
              isNext={isNext} />} />
        </div>
      </div>
      {/*<VerifyFooter isValid={isValid} customer={customer} onAction={action} isNext={isNext} />*/}
    </>
  )
}
